import {Base,Axios} from "@/api/Base"

export class PersistencyBatchAdd extends Base {
    path = "payment/persistencyBatchAdd"
}